const styleSheet = () => ({
  bodyBackground: {
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
  },
  checkBoxHolder: {
    display: 'inline-block',
    // marginRight: "16px",
    position: 'relative',
    zIndex: 1,
  },
  noResults: {
    height: '61px',
    backgroundColor: '#fff',
    color: '#051D39',
    fontSize: '14px',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  firstCell: {
    textAlign: 'left',
    justifyContent: 'start',
    // width: "100%",
    // paddingLeft: "12px",
    // position: "relative",
    wordBreak: 'normal',
  },
  container: {
    position: 'relative',
  },
  row: {
    display: 'none',
  },
  loaderHolder: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    marginTop: '-100px',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
});

export default styleSheet;
